module.exports = __webpack_public_path__ + "static/media/new_message.e2e956ce.mp3";